
export const formatNumberCommas = (number) => {
  if (number === undefined || number === null) {
    return "0";
  }
  return number.toLocaleString(); // undefined나 null이 아닐 때만 toLocaleString 호출
};